import Icon from "../misc/Icon";
import {faMeteor, faRightToBracket} from "@fortawesome/free-solid-svg-icons";
import React, {useState} from "react";
import {OverlayContainer} from "../misc/ImageViewer";
import Settings from "../settings/Settings";
import {schemas} from "../../config";
import SelectProject from "./SelectProject";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {setSchemaManagePageActive} from "../../features/schemaManageSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


function logout(project: string) {
    fetch(schemas[project].backend + '/logout.php', {credentials: 'include'})
        .then(() => {
            localStorage.removeItem('project')
            window.location.href = '/login.html'
        })
}

export default function HeadActions({projectName, toggleActions}: {
    projectName: string,
    toggleActions: (arg0: boolean) => void
}) {
    const [isSettingsOpen, setIsSettingsOpen] = useState<boolean>(false)
    const [isProjectsOpen, setIsProjectsOpen] = useState<boolean>(false)

    const isUserAdmin = useAppSelector(state => state.project.isUserAdmin);
    const isSchemaManageActive = useAppSelector(state => state.schemaManage.active);

    const dispatch = useAppDispatch();

    return <>
        <div className="head-actions flex fl-col">
            <ul className="list">
                <li className={'flex fl-al-ce'}>
                    <div className="dot"/>
                    <button className="header-action-btn" onClick={() => setIsSettingsOpen(!isSettingsOpen)}>
                        Налаштування
                    </button>
                </li>
                <li className={'flex fl-al-ce'}>
                    <div className="dot"/>
                    <button className="header-action-btn" onClick={() => setIsProjectsOpen(!isProjectsOpen)}>
                        Список акцій
                    </button>
                </li>
                {isUserAdmin && <li className={'flex fl-al-ce'}>
                    <div className="dot"/>
                    <button className="header-action-btn"
                            onClick={() => {
                                toggleActions(isSchemaManageActive)
                                dispatch(setSchemaManagePageActive(!isSchemaManageActive))
                            }}>
                        {isSchemaManageActive ? "Повернутись в нормальний режим" : "Керувати схемами"}
                        <FontAwesomeIcon icon={faMeteor} className={'fa-color'}
                                         style={{width: '1.2rem', height: '1.2rem', marginLeft: '.4rem'}}/>
                    </button>
                </li>}
            </ul>
            <div>
                <button className="logout" onClick={() => logout(projectName)}>
                    <Icon src={"/win-icons/Exit%20(gray).ICO"}
                          title={'Вийти'} alt={'Вийти'}
                          width={'1.2rem'}
                          height={'1.2rem'}
                          className={'fa-rotate-180'}
                          component={faRightToBracket}
                    />
                    <span>Вийти</span>
                </button>
            </div>
        </div>
        {isSettingsOpen && <OverlayContainer onClick={() => setIsSettingsOpen(false)} $isVisible={isSettingsOpen}>
            <Settings close={() => setIsSettingsOpen(false)}/>
        </OverlayContainer>}
        {isProjectsOpen && <OverlayContainer onClick={() => setIsProjectsOpen(false)} $isVisible={isProjectsOpen}>
            <SelectProject close={() => setIsProjectsOpen(false)}/>
        </OverlayContainer>}
    </>
}
